import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortCurrency'
})
export class ShortCurrencyPipe implements PipeTransform {
  transform(value: number | string, currencySymbol: string = 'Rs'): string {
    if (value == null || value === undefined || value === '') return 'No Data';

    // Convert string to number if needed
    const numValue = typeof value === 'string' ? parseFloat(value) : value;

    // Check if conversion resulted in NaN
    if (isNaN(numValue)) return 'No Data';

    const abs = Math.abs(numValue);
    let suffix = '';
    let shortValue = numValue;

    if (abs >= 1_000_000_000) {
      shortValue = numValue / 1_000_000_000;
      suffix = 'B';
    } else if (abs >= 100_000) {
      shortValue = numValue / 1_000_000;
      suffix = 'M';
    } else if (abs >= 1_000) {
      shortValue = numValue / 1_000;
      suffix = 'k';
    }

    if(shortValue === 0 || abs === 0) {
     return "0";
    }

    return `${shortValue.toFixed(1)}${suffix} ${currencySymbol}`;
  }
}